import Disturber from "./Disturber";

export default function (props) {


    let baseUrl = document.querySelector('[data-checkout]').dataset.env === 'production'
        ? 'https://login.e-recht24.de/redirect?to='
        : 'https://login.e-recht24.dev/redirect?to=';

    const loginUrl = baseUrl + window.location.href;

    return (
        <Disturber>
            <p>
                <b>Haben Sie bereits ein eRecht24 Kundenkonto?</b><br/>
                Damit der neue Tarif Ihrem aktuellen Konto zugeordnet wird, können Sie sich <a
                className={'font-bold text-blue hover:text-gray-very-dark hover:underline hover:cursor-pointer'} href={loginUrl}>hier anmelden</a>.
            </p>
        </Disturber>
    )
}
